/**
 * API ENDPOINT
 */
export const apiEndpointBaseUrl = 'https://user.gmts.eplatform.vn/'
export const corporateSiteUrl = 'https://shop.gmts.eplatform.vn'
export const apiEndpointWebBaseUrl = 'https://user.gmts.eplatform.vn/webapi/'
export const apiVersion = 'v1'
export const apiKey = 'AIzaSyBhPfsXcVpLNplWNo5ncpvNYU_PO0VLigs'
export const dynamicLinkDomain = 'https://gmts.page.link'
export const androidApplicationId = 'jp.gmts.android'
export const androidFallbackUrl = 'https://play.google.com/store/apps/details?id=app.gmts.android'
export const androidMinimumVersion = 1
export const iOSApplicationId = 'jp.gmts.ios'
export const iOSFallbackUrl = 'https://apps.apple.com/us/app/gmts/id1586331177'
export const iOSMinimumVersion = 0
